import Vue from 'vue'
import VueRouter from 'vue-router'
import MobileInfo from "../views/MobileInfo";
import awaken from "../views/awaken";
import awakenWxWork from "../views/awaken_wxwork";
import awakenTest from "../views/awakenTest";
import awakenMiddle from "../views/middle"
import teleprompter from "../views/teleprompter_awaken"
import childlike from "../views/child_like_awaken"

Vue.use(VueRouter)

const routes = [
  {
    path: '/app/info',
    name: 'MobileInfo',
    component: MobileInfo
  },
  {
    path: '/app/test',
    name: 'awakenTest',
    component: awakenTest
  },
  {
    path: '/middle',
    name: 'awakenMiddle',
    component: awakenMiddle
  },
  {
    path: '/app',
    name: 'awaken',
    component: awaken
  },
  {
    path: '/teleprompter',
    name: 'teleprompter',
    component: teleprompter,
    meta: {
      title: "提词蛙智能提词器"
    }
  },
  {
    path: '/childlike',
    name: 'childlike',
    component: childlike,
    meta: {
      title: "幼趣欢迎您"
    }
  },
  {
    path: '/app/wxwork',
    name: 'awakenWxWork',
    component: awakenWxWork
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/awaken',
  routes
})

export default router
